__turbopack_context__.v({
  "root": "frachter-logo-module-scss-module__RQ-3IG__root",
});
